export enum ORDER_CHANNEL_KEY {
  ONLINE_EDITOR = 'ips',
  DESKTOP_SOFTWARE = 'hps',
  MOBILE_SOFTWARE = 'mps',
}

export type OrderChannels = {
  online?: string;
  software?: {
    os: string;
    type: ORDER_CHANNEL_KEY.DESKTOP_SOFTWARE | ORDER_CHANNEL_KEY.MOBILE_SOFTWARE;
    link: string;
  };
};
